import React, { useRef, useEffect } from 'react';
import FenceLayer from './FenceLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {
        data,
        id: key,
        _key,
        show = true,
        groupLayer,
    } = props;
    const layerRef = useRef();
    const { map } = useProps();

    useEffect(() => {
        let layer = new FenceLayer({
            ...props,
            key: key || _key,
            map
        });

        // 注册事件
        registerEventLayer(layer, props);

        if (groupLayer) {
            groupLayer.addLayer(layer);
        } else {
            map.addLayer(layer);
        }

        layerRef.current = layer;
        return () => {
            if (groupLayer) {
                groupLayer.removeLayer(layer);
            } else {
                map.removeLayer(layer);
            }
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.loadData(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    return <></>;
}
